"use client"

import React, { createContext, useContext, useMemo } from "react"
import { useEIP1193Provider } from "@/components/useEIP1193Provider"

type WalletContextValue = ReturnType<typeof useEIP1193Provider>

const WalletContext = createContext<WalletContextValue | null>(null)

export function WalletProvider({ children }: { children: React.ReactNode }) {
  const value = useEIP1193Provider()
  const memo = useMemo(() => value, [value.provider, value.address, value.type, value.connecting, value.error])
  return <WalletContext.Provider value={memo}>{children}</WalletContext.Provider>
}

export function useWallet() {
  const ctx = useContext(WalletContext)
  if (!ctx) throw new Error("useWallet must be used within WalletProvider")
  return ctx
}


